import { Fragment } from "react";
import PageDependencies from "../../../../../Feature/PageDependencies";

const LightingDataTable = (props)=>{
    const { 
        useState,
        ServerSideDataTable,
    } = PageDependencies();
    const debug = props.debug === undefined ? false : props.debug;
    const [data, setData] = useState([]);
    const tableId = "Lighting_afa07309-239f-4545-a54d-448e0bc545da";
    const tableReload = props.tableReload;
    const extraPostModel = props.extraPostModel;
    const url = props.url;
    const columns =[
      { name: "zoneName", text: "Zone Name", width: "35%" },
      { name: "zoneType", text: "Zone Type", width: "15%" },
      { name: "zoneArea", text: "Area", width: "15%" },
      { name: "energyConsumption", text: "Energy Consumption", width: "20%" },
      { name: "cO2Emission", text: "CO2 Emission", width: "15%" }
    ];

      return(<Fragment>
            <ServerSideDataTable
              disableSorting
              removePaging
              removeSearch
              debug ={debug}
              id={tableId}
              location="Lighting"
              data={data}
              setData={setData}
              reload={tableReload}
              columns={columns}
              dataSource={{ isAuth: true, url: url }}
              extraPostModel={extraPostModel}
              ></ServerSideDataTable>
      </Fragment>);
}
export default LightingDataTable;